// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.weak-set.from.js
// module id = +1ZA
// module chunks = 0